import { Effect, Request, RequestResolver } from 'effect';
import { TemplateId } from '../template';
import * as Url from '../../../url';
import { AuthoringError } from '../authoringService';
import { Schema } from '@effect/schema';
export class CreateTemplate extends Request.TaggedClass('@fixtuur/GavelTemplatesAuthoringService/CreateTemplate') {
}
export const makeCreateTemplateResolver = (http) => RequestResolver.fromEffect((request) => {
    const url = Url.join(request.baseUrl, `/api/v1/${request.tenantId}/templates`);
    return http
        .post(url, { authorization: request.token, 'content-type': 'application/json' }, JSON.stringify(request.template))
        .pipe(Effect.flatMap(res => Schema.decodeUnknown(TemplateId)(res.body)), Effect.mapError(originalError => new AuthoringError({ originalError })));
});
